import { DeviceStatusType } from '@portals/types';

export interface DeviceStatusIncidentTimelineWidgetFormType {
  name: string;
}

export interface DeviceStatusTimelineType {
  name: string;
  start: Date;
  end: Date;
  y?: number;
  status: DeviceStatusType;
  meta: {
    actualStart: Date;
    actualEnd: Date;
  };
}

export const TIMELINE_RANGE_OPTIONS = {
  oneHour: 'oneHour',
  sixHours: 'sixHours',
  oneDay: 'oneDay',
  sevenDays: 'sevenDays',
} as const;

export const TIMELINE_RANGE_OPTIONS_NUMERIC_VALUES = {
  oneHour: 3600000,
  sixHours: 21600000,
  oneDay: 86400000,
  sevenDays: 604800000,
} as const satisfies Record<TimelineRangeNamesType, number>;

export type TimelineRangeNamesType = keyof typeof TIMELINE_RANGE_OPTIONS;
